const collocate= {
    path: 'collocate',
    component: resolve => require(['../../../../../../pages/admin/merchant/dispose/collocate'], resolve),
    meta: {
      requireAuth: true
    }
  }
  
  export default collocate